module.exports = __webpack_public_path__ + "img/Cuba.0a3ed034.svg";